import Axios from 'axios';
import { API } from 'core';

export const voteUpAlert = (incidentId: string, alertId: string) => {
  return Axios.put(
    `${API.config.batman}/organizations/${API.config.organizationId}/incidents/${incidentId}/alerts/${alertId}/vote-up`,
  );
};
